(() => {
  const query = document.querySelector('.module-whyus');
  if (!query) return;
  let timerId;

  const delay = 10000;

  const animateValue = (obj, start, end, duration) => {
    let startTimestamp = null;

    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      obj.innerHTML = Math.floor(progress * (end - start) + start);

      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };

    window.requestAnimationFrame(step);
  };

  const setStatBoxActive = (item) => {
    const siblings = Array.from(item.parentElement.children);

    siblings.forEach((el) => {
      el.classList.remove('nActive');
    });

    item.classList.add('nActive');
    const img = item.getAttribute('data-box');
    document.querySelectorAll('.stat-box').forEach((el) => {
      el.classList.remove('nActive');
    });

    document.querySelector(`.stat-box[data-img="${img}"]`)?.classList.add('nActive');
  };

  document.querySelectorAll('.js-stat-counter').forEach((item) => {
    const startAnim = () => {
      item.querySelectorAll('.stat-box-num').forEach((el) => {
        const targetNum = el.getAttribute('data-count');

        animateValue(el, 0, targetNum, 5000);
      });
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          startAnim();
          observer.disconnect();
        }
      });
    });

    observer.observe(item);
  });

  const animateSibling = () => {
    const siblings = document.querySelectorAll('.whyus-stat-box');
    const curIndex = Array.prototype.indexOf.call(siblings, document.querySelector('.whyus-stat-box.nActive'));
    const nextSibling = siblings[curIndex + 1] || siblings[0];
    setStatBoxActive(nextSibling);
  };

  // Begin the animation without needing to click.

  document.querySelectorAll('.whyus-stat-box').forEach((item, index) => {
    if (index === 0) {
      setStatBoxActive(item);
    }
  });

  const startInterval = () => {
    timerId = setInterval(animateSibling, delay);
  };

  // Prevent multiple intervals.

  if (timerId) {
    clearInterval(timerId);
  }

  startInterval();
  const statBoxes = document.querySelector('.whyus-stat-boxes');

  if (!statBoxes) return;

  const observer = new IntersectionObserver((e) => {
    e.forEach((entry) => {
      if (entry.isIntersecting) {
        observer.disconnect();

        animateSibling();
      }
    });
  });

  observer.observe(statBoxes);

  document.querySelectorAll('.module-whyus').forEach((item) => {
    item.parentElement.style.overflow = 'hidden';
  });
})();
